module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAGFBMVEXoES0idUv6tRkpj0cAh1HoES3ycSL80RaCoZLMAAAABHRSTlPU+Pj+JxLekgAAADxJREFUeNpjNGbABO8Z8AFGFyyCxqNaRrWMahnVMqplVAsNtCiRrkVwVMuollEto1pGtYxqoVCLIMm9JACnPBxMZIzXegAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/bj.png
// module id = v7s1
// module chunks = 0